import { connect } from 'react-redux';
import React, { Component } from 'react';
import ActionBar from 'scenes/V2/Shared/ActionBar';
import { changeProfileField } from 'redux/ducks/Post/Profile';
import { getSettingDetail, getSettingName } from 'helpers/enums';
import { isId, trackMixpanelPageView } from 'helpers/post';
import BasicOptionCard from 'scenes/V3/CreateAccountScene/OptionCards/BasicOptionCard';
import { Button } from 'reactstrap';

class EventSettingDetail extends Component {
  constructor(props) {
    super(props);
    props.initialize('EventSettingDetail');
    this.state = {
      selectedSettingDetailId: isId(props.profile.settingDetailId) ? props.profile.settingDetailId : null,
    };
  }

  componentDidMount() {
    if (!this.props.editMode) {
      document.body.classList.add('hide-chat');
    }
    trackMixpanelPageView('create-event/setting-detail', this.props.user);
  }

  componentWillUnmount() {
    document.body.classList.remove('hide-chat');
  }

  onSelect = setting => () => {
    this.setState({ selectedSettingDetailId: setting.id });
  };

  onContinue = () => {
    const { selectedSettingDetailId } = this.state;
    if (!isId(selectedSettingDetailId)) return;

    this.props.onChangeProfile('settingDetailId', selectedSettingDetailId);
    this.props.history.push(`${this.props.baseUrl}/profile`);
  };

  getScreenTitle = eventSettingId => {
    const setting = getSettingName(eventSettingId);
    const SCREEN_TITLES = {
      Sports: 'What type of sporting event is it?',
      Industrial: 'Where will the job take place?',
      Medical: 'Where will the job take place?',
      'Performing Arts': 'Where will the job take place?',
    };
    return SCREEN_TITLES[setting] || 'What type of job is it?';
  };

  renderOptions() {
    const { profile } = this.props;
    const { selectedSettingDetailId } = this.state;
    const settingDetails = getSettingDetail(profile.eventSettingId);

    return settingDetails.map(setting => (
      <BasicOptionCard
        key={setting.id}
        title={setting.name}
        onClick={this.onSelect(setting)}
        selected={setting.id === selectedSettingDetailId}
        padding="md"
        fontSize="18px"
      />
    ));
  }

  renderCreateFlow() {
    const { profile } = this.props;
    const buttonDisabled = !isId(this.state.selectedSettingDetailId);

    return (
      <div className="event-setting-detail">
        <main>
          <header>
            <div className="screen-title gotham-bold-font">{this.getScreenTitle(profile.eventSettingId)}</div>
          </header>
          <div className="content">
            <div className="setting-detail-options">{this.renderOptions()}</div>
          </div>
        </main>
        <div className="navigation-buttons">
          <Button onClick={this.onContinue} className="continue-button" disabled={buttonDisabled}>
            <div>Continue &#8594;</div>
          </Button>
        </div>
      </div>
    );
  }

  render() {
    const { profile, baseUrl, editMode } = this.props;

    if (editMode) {
      return (
        <div className="event-setting-detail event-setting-detail--edit">
          <header>
            <div className="screen-title">{this.getScreenTitle(profile.eventSettingId)}</div>
          </header>
          <main>
            <div className="setting-detail-options">{this.renderOptions()}</div>
          </main>
          <ActionBar
            editMode={editMode}
            currentStep="setting-detail"
            backTo={`${baseUrl}/setting`}
            onSaveAndContinue={this.onContinue}
            nextDisabled={() => !isId(this.state.selectedSettingDetailId)}
          />
        </div>
      );
    }

    return this.renderCreateFlow();
  }
}

const mapStateToProps = (state, ownProps) => ({
  eventProfessionId: 0,
  settingDetails: state.enums.settingDetails,
  profile: state.post.profile,
  details: state.post.details,
  user: state.session.currentUser,
});

const mapDispatchToProps = dispatch => ({
  onChangeProfile: (name, value) => dispatch(changeProfileField({ name, value })),
});

export default connect(mapStateToProps, mapDispatchToProps)(EventSettingDetail);
